<template>
  <div class="text-center">
    <p>
      <span v-if="!benhNhan.tier" class="badge badge-secondary">Chưa cập nhật</span>
      <span v-else-if="benhNhan.tier === 'nc0'" class="badge badge-success">NC0</span>
      <span v-else-if="benhNhan.tier === 'nc1'" class="badge badge-info">NC1</span>
      <span v-else-if="benhNhan.tier === 'nc2'" class="badge badge-primary">NC2</span>
      <span v-else-if="benhNhan.tier === 'nc3'" class="badge badge-warning">NC3</span>
      <span v-else class="badge badge-danger">NC4</span>
    </p>
    <br />
    <p v-if="benhNhan.nextTier && benhNhan.tier && benhNhan.nextTier !== benhNhan.tier">
      <span class="badge badge-warning glow"
        ><b-spinner type="grow" small></b-spinner> Cần duyệt chuyển {{ item.nextTier }}</span
      >
    </p>
  </div>
</template>

<script>
export default {
  props: {
    benhNhan: {
      type: Object,
      required: true,
      validator: value => !!value._id,
    },
  },
};
</script>
